<template>
	<v-col class="sponsorisasi">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Dashboard</div>
		</div>

		<div class="pt-1 pb-5 mb-3 d-flex font-size-10 grey--text">
			<router-link to="/">
				<div class="d-flex">
					<v-icon small color="grey">mdi-home</v-icon>
					<div class="pl-2 grey--text">Dashboard</div>
				</div>
			</router-link>
		</div>

		<!-- new dashboard -->
		<template v-if="!loading">
			<div class="mt-5">
				<v-row>			
					<v-scroll-x-transition mode="in-out">
						<v-col cols="12" sm="6" md="6" class="align-stretch" v-if="Object.values(myProfile).length > 0">
							<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height">
								<v-row>
									<v-col cols="12" class="d-flex flex-row align-center justify-space-between">
										<div class="font-size-12 cl-grey font-weight-500">Profil</div>
										<v-btn
												color="primary"
												small
												text
												@click="goProfile"
											>
												Lihat Detail
											</v-btn>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" sm="12" md="4" class="d-flex flex-column flex-stretch text-center justify-start align-center">
										<v-img height="120" width="120" class="user-img mx-auto rounded-pill hover-shadow" style="max-height: 120px;" :src="(myProfile.member_image_url) ? myProfile.member_image_url : '/assets/image/profile-pict.png'"></v-img>
										<div class="bottom-shadow"></div>
									</v-col>

									<v-col cols="12" sm="12" md="8">
										<div class="mb-4 font-size-14 font-weight-600 cl-primary text-uppercase">{{ myProfile.member_name }}</div>
										<v-row class="mb-3">
											<v-col cols="12" sm="12" md="6" v-if="myProfile.network_code">
												<div class="font-size-10 cl-grey">Kode Mitra</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.network_code }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Tanggal Gabung</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_join_datetime | tanggal }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" v-if="!myProfile.network_code">&nbsp;</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Sponsor</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_sponsor_network_code ? myProfile.member_sponsor_network_code : '-' }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Upline</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.network_upline_network_code ? myProfile.network_upline_network_code : '-' }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Email</div>
												<div class="font-size-11 cl-grey font-weight-600" v-html="$options.filters.longText(myProfile.member_email, 20)"></div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Nomor HP</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_mobilephone ? myProfile.member_mobilephone : '-' }}</div>
											</v-col>
										</v-row>

										<template v-if="myProfile.network_type == 'silver' && myProfile.network_type == 'gold' && isActiveMember">
											<v-row class="mb-1">
												<v-col cols="12" sm="12" class="pt-1">
														<v-btn
															color="primary"
															outlined
															block
															@click="gotoUpgrade"
														><v-icon dense class="mr-1">mdi-shield-account-outline</v-icon>Upgrade Kemitraan</v-btn>
												</v-col>
											</v-row>
										</template>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-scroll-x-transition>

					<template v-if="isActiveMember">
						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="12" md="6" class="align-stretch" v-if="networkType">
								<v-card class="pa-5 elevation-0 rounded-lg hover-shadow mb-5 d-sm-block d-md-none d-xl-none">
									<div class="d-flex flex-column justify-start">
										<div class="d-flex flex-row align-center mb-3">
											<img class="img-fluid img-darken" src="/assets/icon/wallet.svg" width="24">
											<div class="font-size-12 gray--text darken-1 pl-3 font-weight-bold" style="line-height: normal;">Total Saldo Belanja</div>
										</div>

										<div class="font-size-18 cl-primary darken-5 font-weight-600">{{ ewalletSummary.ewallet_product_balance | toRupiah }}</div>
									</div>
								</v-card>

								<v-card class="pa-5 elevation-0 rounded-lg hover-shadow mb-5 d-none d-md-block">
									<div class="d-flex flex-row align-center justify-space-between">
										<div class="d-flex flex-row align-center">
											<img class="img-fluid img-darken" src="/assets/icon/wallet.svg" width="36">
											<div class="font-size-12 gray--text darken-1 pl-4 font-weight-bold" style="line-height: normal;">Total<span class="d-block">Saldo Belanja</span></div>
										</div>

										<div class="font-size-18 cl-primary darken-5 font-weight-600">{{ ewalletSummary.ewallet_product_balance | toRupiah }}</div>
									</div>
								</v-card>

								<v-card class="pa-8 elevation-0 rounded-lg hover-shadow mitra-card" :class="networkType.classText" style="height: calc(100% - 100px);">
									<template v-if="Object.values(myProfile).length > 0"><upgradedate-alert :myProfile="myProfile" :networkType="myProfile.network_type" style="margin-top: -25px;"></upgradedate-alert></template>
									<v-row justify="center" class="fill-height flex-stretch mt-0">
										<v-col cols="12" sm="12" md="4" class="pa-4 d-flex align-center justify-center">
											<v-img eager width="180" style="height: auto;max-width: 100%;" class="mx-auto" :src="networkType.badges"></v-img>
										</v-col>
										<v-col cols="12" sm="12" md="8">
											<div class="rank-text">
												<div class="font-size-14 font-weight-500" :class="(myProfile.network_type == 'basic') ? 'cl-white' : 'cl-darkgrey'">Peringkat Kemitraan Anda Saat Ini</div>
												<h1 class="font-weight-bold text-uppercase my-3" :style="'color:' + networkType.color">
													<!-- {{ (networkType.type === 'gold') ? 'Gold Star' : (networkType.type === 'repeat_order') ? 'Silver' : networkType.type }} -->
													{{ getNetworkTypeText(myProfile.network_type) }}
												</h1>
												<template v-if="networkType && networkType.type !== 'business' && networkType.type !== 'basic'">
													<div class="d-flex flex-column px-4 font-size-9">
														<div>Akumulasi Pembelanjaan Anda telah mencapai<span class="d-block font-size-16 font-weight-600" :style="'color:' + networkType.color">{{ networkType.belanja }}</span></div>
													</div>
												</template>
											</div>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>
					</template>

					<template v-else>
						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="4" md="6" class="align-stretch" v-if="networkType">
								<v-card class="pa-8 elevation-0 rounded-lg hover-shadow fill-height mitra-card" :class="networkType.classText">
									<v-row justify="center" class="fill-height flex-stretch mt-0">
										<v-col cols="12" sm="12" md="12">
											<div class="rank-text">
												<div class="font-size-14 font-weight-500 yellow--text">Selamat datang <b class="text-uppercase">{{ myProfile.member_name }}</b>,</div>
												<div class="font-size-14 font-weight-500 yellow--text mb-2">Selamat bergabung bersama Makin Jaya Agung</div>

												<div class="font-size-10 font-weight-400 cl-white mb-5">Saat ini anda belum melakukan aktivasi akun, sehingga mungkin beberapa fitur belum dapat anda gunakan.</div>
												<div class="font-size-10 font-weight-600 cl-white mb-5">Segera lakukan aktivasi untuk dapat mengakses fitur-fitur utama kami, melakukan transaksi serta mendapatkan informasi seputar komisi yang anda dapatkan.</div>
												
												<v-btn depressed color="warning" dark large elevation="2" class="white--text rounded-lg text-uppercase font-weight-bold" @click="goActivation">
													<v-icon>mdi-account-reactivate-outline</v-icon>
													<span class="pl-2">Aktivasi Akun Saya</span>
												</v-btn>
											</div>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>
					</template>
				</v-row>
			</div>

			<div class="mt-5">
				<template v-if="certificate.total > 0">
					<v-row class="">
						<v-col cols="12" sm="12" lg="6">
							<Certificate :certificate="certificate" :myprofile="myProfile"></Certificate>
						</v-col>

						<v-col cols="12" sm="12" lg="6">
							<template v-if="serialCount">
								<v-row>
									<template v-for="(serial, ids) in serialCountList">
										<v-col cols="12" :lg="(serial.serial_type_name == 'upgrade' || serial.serial_type_name == 'aktivasi') ? '12' : '4'" class="flex-stretch d-flex" :key="ids">
											<v-card class="pa-5 elevation-0 rounded-lg hover-shadow" width="100%">
												<v-row class="align-start">
													<v-col cols="12" sm="12" md="12" v-if="serial.serial_type_name !== 'upgrade' && serial.serial_type_name !== 'aktivasi'">
														<div class="font-size-18 green--text darken-3 font-weight-600 d-flex flex-row">
															<img class="img-fluid img-darken mr-2" src="/assets/icon/serial_registrasi.svg" style="width: 20px">
															{{ serial.serial_type_count }}
														</div>
														<div class="font-size-11 black--text text-capitalize">Serial {{ (serial.serial_type_name === 'repeatorder') ? 'RO' : serial.serial_type_name }}</div>
													</v-col>

													<v-col cols="12" sm="12" md="12" v-else>
														<v-row>
															<v-col cols="12" sm="12" lg="6" class="d-flex align-center">
																<div class="d-flex flex-row">
																	<img class="img-fluid img-darken mr-4" src="/assets/icon/serial_registrasi.svg" style="width: 40px">

																	<div class="d-flex flex-column">
																		<div class="font-size-18 green--text darken-3 font-weight-600">{{ serial.serial_type_count }}</div>
																		<div class="font-size-11 black--text text-capitalize">Serial {{ (serial.serial_type_name === 'repeatorder') ? 'RO' : serial.serial_type_name }}</div>
																	</div>
																</div>
															</v-col>
															
															<v-col cols="12" sm="12" lg="6">
																<template v-if="serial.serial_type_has_child">
																	<v-row dense>
																		<template v-for="(subSerial, idss) in serial.serial_type_child_detail">
																			<v-col cols="12" :lg="(serial.serial_type_name == 'upgrade') ? '12' : '4'" :key="idss">
																				<div class="d-flex" :class="(serial.serial_type_name == 'upgrade') ? 'flex-row justify-space-between align-center' : 'flex-column'">
																					<span class="d-block mb-0 font-weight-600 font-size-12 mr-1" v-if="serial.serial_type_name == 'aktivasi'">{{ subSerial.serial_type_count }}</span>
																					<div class="d-block text-capitalize cl-black font-size-10">
																						<span v-if="serial.serial_type_name == 'aktivasi'">{{ setSerialAktivasiText(subSerial.serial_type_name) }}</span>
																						<span v-else-if="serial.serial_type_name == 'upgrade'">{{ setSerialUpgradeText(subSerial.serial_type_name) }}</span>
																						<span v-else>{{ subSerial.serial_type_name }}</span>
																					</div>
																					<span class="d-block mb-0 font-weight-600 font-size-14" v-if="serial.serial_type_name == 'upgrade'">{{ subSerial.serial_type_count }}</span>
																				</div>
																			</v-col>
																		</template>
																	</v-row>
																</template>
															</v-col>
														</v-row>
													</v-col>
												</v-row>
											</v-card>
										</v-col>
									</template>
								</v-row>
							</template>
						</v-col>
					</v-row>
				</template>

				<template v-else>
					<v-row v-if="serialCount">
						<template v-for="(serial, ids) in serialCount">
							<v-col cols="12" lg="" class="flex-stretch d-flex" :key="ids">
								<v-card class="pa-5 elevation-0 rounded-lg hover-shadow grey lighten-3">
									<v-row class="align-start">
										<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right d-flex alilgn-start">
											<img class="img-fluid img-darken" src="/assets/icon/serial_registrasi.svg" style="width: 90%;">
										</v-col>
										<v-col cols="10" sm="9" md="9">
											<div class="font-size-18 green--text darken-3 font-weight-600">{{ serial.serial_type_count }}</div>
											<div class="font-size-11 black--text text-capitalize">Serial {{ (serial.serial_type_name === 'repeatorder') ? 'RO' : serial.serial_type_name }}</div>
										</v-col>
									</v-row>
									<hr class="my-2">

									<template v-if="serial.serial_type_has_child">
										<v-row dense>
											<template v-for="(subSerial, idss) in serial.serial_type_child_detail">
												<v-col cols="12" :lg="(serial.serial_type_name == 'upgrade') ? '12' : '4'" :key="idss">
													<div class="d-flex" :class="(serial.serial_type_name == 'upgrade') ? 'flex-row justify-space-between align-center' : 'flex-column'">
														<span class="d-block mb-0 font-weight-600 font-size-12 mr-1" v-if="serial.serial_type_name == 'aktivasi'">{{ subSerial.serial_type_count }}</span>
														<div class="d-block text-capitalize cl-secondary font-size-10">
															<span v-if="serial.serial_type_name == 'aktivasi'">{{ setSerialAktivasiText(subSerial.serial_type_name) }}</span>
															<span v-else-if="serial.serial_type_name == 'upgrade'">{{ setSerialUpgradeText(subSerial.serial_type_name) }}</span>
															<span v-else>{{ subSerial.serial_type_name }}</span>
														</div>
														<span class="d-block mb-0 font-weight-600 font-size-14" v-if="serial.serial_type_name == 'upgrade'">{{ subSerial.serial_type_count }}</span>
													</div>
												</v-col>
											</template>
										</v-row>
									</template>
								</v-card>
							</v-col>
						</template>
					</v-row>
				</template>
			</div>


			<!-- v-if="isActiveMember" -->
			<template>
				<v-row justify="center" class="mt-5" v-if="false">
					<v-col cols="12" sm="12" md="12" xl="12">
						<v-card class="elevation-0 rounded-lg pb-2">
							<div class="px-5 py-3 font-size-12 cl-grey font-weight-500">
								<v-icon dense class="mr-2">mdi-medal</v-icon>
								<span>Reward Promo Sponsorship</span>	
							</div>
							<div class="px-5 pb-3">
								<v-card outlined color="#E0F2F1" class="pa-4 elevation-0 w-100">
									<div class="pb-3 font-size-11 cl-grey font-weight-500">Promo periode 1 April 2022 hingga 30 April 2022</div>
									<div class="d-flex flex-wrap mr-n3">
										<v-col cols="12" md="4" class="pt-0 pl-0" v-for="(promo, i) in sponsorPromo.promo" :key="i">
											<v-card class="elevation-0 hover-shadow w-100">
												<v-card-subtitle class="d-flex flex-column black--text lighten-3 pb-1">
													<span class="font-weight-bold">Reward {{ promo.promo_value }} Point</span>
												</v-card-subtitle>
												<div class="d-block px-4 pb-4 font-size-14 cl-secondary font-weight-600 text-capitalize">{{ promo.promo_label }}</div>
											</v-card>
										</v-col>
										<v-col cols="12" md="4" class="pt-0 pl-0">
											<v-card class="elevation-0 hover-shadow w-100">
												<v-card-subtitle class="d-flex flex-column black--text lighten-3 pb-1">
													<span class="font-weight-bold">Total Point Anda</span>
												</v-card-subtitle>
												<div class="d-block px-4 pb-4 font-size-14 cl-secondary font-weight-600">{{ sponsorPromo.point_now | toNumber }}</div>
											</v-card>
										</v-col>
									</div>
									<div class="font-size-10 cl-grey font-weight-500">Poin akan bertambah ketika Anda berhasil merekrut mitra baru dan atau ketika mitra yang Anda sponsori melakukan upgrade</div>
									<div class="pt-1 font-size-10 cl-grey">
										<div class="font-weight-bold" v-if="parseInt(sponsorPromo.point_now) >= 50">Anda telah mendapatkan reward <span class="cl-secondary font-weight-bold">Subsidi 50% Tour Turki</span> silakan menghubungi perusahaan</div>
										<div  class="font-weight-bold" v-else-if="parseInt(sponsorPromo.point_now) >= 100">Anda telah mendapatkan reward <span class="cl-secondary font-weight-bold">Gratis Tour Turki</span> silakan menghubungi perusahaan</div>
										<div v-else>Terus kumpulkan point agar Anda mendapatkan reward</div>
									</div>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>

				<v-row justify="center" class="mt-5">
					<v-col cols="12" sm="12" md="12" xl="12">
						<v-card class="elevation-0 rounded-lg pb-2">
							<div class="d-flex align-center px-5 py-3 font-size-12 cl-grey font-weight-500">
								<v-icon dense class="mr-2">mdi-wallet-giftcard</v-icon>
								<span>Potensi Komisi Hari Ini ({{ new Date() | toDateMonthSortYear }})</span>
							</div>
							<div class="d-block px-5 pb-2"></div>
								
								<v-row class="d-flex flex-column flex-lg-row ma-2">
									<v-col cols="12" md="12" lg="4" class="py-1 flex-stretch">
										<v-card outlined class="elevation-0 fill-height">
											<v-card-title class="black--text lighten-3 font-weight-bold pb-4">Komisi Sponsor</v-card-title>
											<v-card-text>
												<v-row dense>
													<template v-for="(komisi, idk) in bonusToday.sponsor">
														<v-col cols="12" lg="6" :key="idk">
															<v-card outlined color="#f5f5f5" class="elevation-0 hover-shadow">
																<v-card-subtitle class="black--text lighten-3 font-weight-bold pb-3" style="line-height: normal; font-size: 13px!important; width: 80%;">{{ (komisi.label === 'Komisi Sponsor') ? 'Komisi Sponsor Reguler' : komisi.label }}</v-card-subtitle>
																<div class="d-block px-4 pb-4 font-size-11 green--text font-weight-600">{{ komisi.bonus | toRupiah }}</div>
															</v-card>
														</v-col>
													</template>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>

									<v-col cols="12" md="12" lg="4" class="py-1 flex-stretch">
										<v-card outlined class="elevation-0 fill-height">
											<v-card-title class="black--text lighten-3 font-weight-bold pb-4">Komisi Pasangan</v-card-title>
											<v-card-text>
												<v-row dense>
													<template v-for="(komisi, idk) in bonusToday.match">
														<v-col cols="12" lg="6" :key="idk">
															<v-card outlined color="#f5f5f5" class="elevation-0 hover-shadow">
																<v-card-subtitle class="black--text lighten-3 font-weight-bold pb-3" style="line-height: normal; font-size: 13px!important; width: 100%;">{{ (komisi.label === 'Komisi Pasangan') ? 'Komisi Pasangan Reguler' : komisi.label }}</v-card-subtitle>
																<div class="d-block px-4 pb-4 font-size-11 green--text font-weight-600">{{ komisi.bonus | toRupiah }}</div>
															</v-card>
														</v-col>
													</template>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>

									<v-col cols="12" md="12" lg="4" class="py-1 flex-stretch">
										<v-card outlined class="elevation-0 fill-height">
											<v-card-title class="black--text lighten-3 font-weight-bold pb-4">Komisi Lainnya</v-card-title>
											<v-card-text>
												<v-row dense>
													<template v-for="(komisi, idk) in bonusToday.other">
														<v-col cols="12" lg="6" :key="idk">
															<v-card outlined color="#f5f5f5" class="elevation-0 hover-shadow">
																<v-card-subtitle class="black--text lighten-3 font-weight-bold pb-3" style="line-height: normal; font-size: 13px!important; width: 90%;">{{ komisi.label }}</v-card-subtitle>
																<div class="d-block px-4 pb-4 font-size-11 green--text font-weight-600">{{ komisi.bonus | toRupiah }}</div>
															</v-card>
														</v-col>
													</template>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
						</v-card>
					</v-col>
				</v-row>

				<div class="mt-5">
					<v-row>
						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="12" md="4" lg="4">
								<v-card class="pa-1 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth card-supreme">
									<v-card-text>
										<v-row>
											<v-col cols="12" lg="12">
												<div class="d-flex flex-row align-center justify-content-start" style="height: 60px;">
													<div class="py-2 mr-5">
														<v-img width="60" class="mx-auto" style="height: auto; max-height: auto;" src="/assets/icon/coins.svg"></v-img>
													</div>
													
													<div>
														<label class="d-block font-weight-bold mb-2" style="font-size: 14px;">
															Total Komisi Anda
														</label>

														<h2>
															<div class="text-left font-weight-bold" style="color: #000;">{{ listSummaryBonus.totalAcc | toRupiah }}</div>
														</h2>
													</div>
												</div>
												<hr class="mt-5 mb-5" style="filter: opacity(0.35);">
											</v-col>

											<v-col cols="12" lg="6" class="d-flex align-start flex-column">
												<h3 class="">
													<div class="text-center font-weight-500" style="color: #028b43;font-size: 18px;">{{ listSummaryBonus.totalPaid | toRupiah }}</div>
												</h3>
												<div class="font-size-10 text-center cl-grey text-capitalize"><v-icon dense class="mr-1">mdi-swap-vertical-bold</v-icon>Total Dibayarkan</div>
											</v-col>
											
											<v-col cols="12" lg="6" class="d-flex align-end flex-column">
												<h3 class="">
													<div class="text-center font-weight-500" style="color: #028b43;font-size: 18px;">{{ listSummaryBonus.totalSaldo | toRupiah }}</div>
												</h3>
												<div class="font-size-10 text-center cl-grey text-capitalize">Total Saldo Komisi<v-icon dense class="ml-1">mdi-wallet</v-icon></div>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>
						
						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="12" md="4" lg="4">
								<v-card class="pa-1 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth card-supreme">
									<v-card-text>
										<v-row>
											<v-col cols="12" lg="12">
												<div class="d-flex flex-row align-center justify-space-between" style="height: 60px;">
													<label class="font-weight-bold" style="font-size: 18px;" v-if="!extraReward.claim">
														Saldo Extra Reward
													</label>
													<label class="font-weight-bold d-flex flex-column" style="font-size: 12px;" v-else>
														Saldo Extra Reward
														<v-chip
															class="mt-1 py-2"
															outlined
															x-small
															color="red"
															text-color="red"
														>
															<v-icon x-small dense class="mr-1">mdi-information-outline</v-icon> Sudah Dicairkan
														</v-chip>
													</label>
													<h2>
														<div class="text-center font-weight-bold" style="color: #000;">{{ (parseInt(extraReward.saldo)) | toRupiah }}</div>
													</h2>
												</div>
												<hr class="mt-5 mb-5" style="filter: opacity(0.35);">
											</v-col>

											<v-col cols="12" lg="6" class="d-flex align-start flex-column">
												<h3 class="">
													<div class="text-center font-weight-500" style="color: #028b43;font-size: 20px;">{{ (parseInt(extraReward.point_left)) | toNumber }}</div>
												</h3>
												<div class="font-size-9 text-center cl-grey text-capitalize"><v-icon dense class="mr-1">mdi-arrow-left-thick</v-icon>Point Kiri</div>
											</v-col>
											
											<v-col cols="12" lg="6" class="d-flex align-end flex-column">
												<h3 class="">
													<div class="text-center font-weight-500" style="color: #028b43;font-size: 20px;">{{ (parseInt(extraReward.point_right)) | toNumber }}</div>
												</h3>
												<div class="font-size-9 text-center cl-grey text-capitalize">Point Kanan<v-icon dense class="ml-1">mdi-arrow-right-thick</v-icon></div>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>
						
						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="12" md="4" lg="4" v-if="Object.values(myProfile).length > 0">
								<v-card class="pa-1 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth card-supreme">
									<v-card-text>
										<v-row>
											<v-col cols="12" lg="12">
												<div class="d-flex flex-row align-center justify-space-between" style="height: 60px;">
													<label class="font-weight-bold" style="font-size: 18px;">Total PV<small class="d-block">Saat ini</small></label>
													<h1>
														<div class="text-center font-weight-bold" style="color: #000;">{{ (parseInt(myProfile.network_total_downline_left) + parseInt(myProfile.network_total_downline_right)) | toNumber }}</div>
													</h1>
												</div>
												<hr class="mt-5 mb-5" style="filter: opacity(0.35);">
											</v-col>

											<v-col cols="12" lg="6" class="d-flex align-start flex-column">
												<h3 class="">
													<div class="text-center font-weight-500" style="color: #9b141b;font-size: 20px;">{{ (parseInt(myProfile.network_total_downline_left)) | toNumber }}</div>
												</h3>
												<div class="font-size-9 text-center cl-grey text-capitalize"><v-icon dense class="mr-1">mdi-arrow-left-thick</v-icon>PV Kiri</div>
											</v-col>
											
											<v-col cols="12" lg="6" class="d-flex align-end flex-column">
												<h3 class="">
													<div class="text-center font-weight-500" style="color: #9b141b;font-size: 20px;">{{ (parseInt(myProfile.network_total_downline_right)) | toNumber }}</div>
												</h3>
												<div class="font-size-9 text-center cl-grey text-capitalize">PV Kanan<v-icon dense class="ml-1">mdi-arrow-right-thick</v-icon></div>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>
						
					</v-row>	
				</div>

				<div class="mt-5">
					<v-row v-if="!growthLoading">
						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="6" md="6" class="flex-stretch">
								<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height">
									<div class="font-size-12 cl-grey font-weight-500 text-center">Rincian Komisi</div>
									
									<div id="chart-rincian-komisi" class="fill-height py-4">
										<template v-if="getTotalBonus(listSummaryBonus) === 0">
											<div class="empty-pie" style="width:135px; height: 135px;"></div>
										</template>
										<apexchart type="pie" :options="rincianKomisi.chartOptions" :series="rincianKomisi.series" height="380"></apexchart>
									</div>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>

						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="6" md="6" class="flex-stretch">
								<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height chart-komisi">
									<div class="font-size-12 cl-grey font-weight-500">Summary Komisi</div>
									<div id="chart-summary-komisi">
										<apexchart type="bar" height="380" :options="summaryKomisi.chartOptions" :series="summaryKomisi.series"></apexchart>
									</div>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>
					</v-row>
				</div>
			</template>
		</template>

		<template v-else>
			<loaderdashboard :isActiveMember="isActiveMember" :networkType="networkType"></loaderdashboard>
		</template>
		<!-- end new dashboard -->

		<!-- growth network summary -->
		<template v-if="isActiveMember">
			<template v-if="!growthLoading">
				<div class="mt-5">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-row>
								<v-scroll-x-transition mode="in-out">
									<v-col cols="12" sm="5" md="6" v-if="Object.values(listSummaryBonus).length > 0">
										<v-card class="pa-4 elevation-0 rounded-lg h-100-pct hover-shadow chart-membergrowth">
											<v-row>
												<v-col cols="12">
													<div class="font-size-12 cl-grey font-weight-500">Pertumbuhan Mitra Minggu Ini</div>
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="12">
													<div id="chart-netgrow">
														<template v-if="growthSummary.length > 0">
															<apexchart type="area" height="350" :options="netGrow.chartOptions" :series="netGrow.series"></apexchart>
														</template>
														<template v-else>
															<div class="d-flex flex-column fill-height align-center justify-center pa-5">
																<v-icon color="grey" large>mdi-information-outline</v-icon>
																<div class="font-size-10 mt-4 text-center cl-grey">Belum ada data pertumbuhan mitra yang ditampilkan.</div>
															</div>
														</template>
													</div>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</v-scroll-x-transition>
								
								<v-scroll-x-reverse-transition mode="in-out">
									<v-col cols="12" sm="7" md="6">
										<v-card class="pa-4 elevation-0 rounded-lg h-100-pct hover-shadow">
											<v-tabs
												v-model="tab"
												background-color="transparent"
											>
												<v-tab>
													<div class="font-size-12 cl-grey font-weight-500">Mitra Terbaru</div>
												</v-tab>
												<!-- <v-tab>
													<div class="font-size-12 cl-grey font-weight-500">Top Extra Reward</div>
												</v-tab> -->
											</v-tabs>

											<v-tabs-items v-model="tab">
												<v-tab-item>
													<v-card
														color="basil"
														flat
													>
														<v-card-text>
															<v-row class="mb-4">
																<v-col cols="12" sm="12" md="5" class="d-flex align-start pb-0 font-weight-600">
																	Nama Mitra
																</v-col>
																<v-col cols="6" sm="6" md="2" class="px-sm-0 pb-0 text-left text-md-right font-weight-600">
																	Kemitraan
																</v-col>
																<v-col cols="6" sm="6" md="2" class="px-sm-0 pb-0 text-right text-md-center font-weight-600">
																	Posisi
																</v-col>
																<v-col cols="12" sm="12" md="3" class="pt-0 pb-0 pt-sm-3 text-left text-md-right font-weight-600">
																	Tgl. Gabung
																</v-col>
															</v-row>
															<!-- <template v-if="listDownline.length > 0">
																<v-row dense class="my-1" :class="(idx % 2 > 0) ? 'bg-striped' : ''" v-for="(downline, idx) in fiveDownline" :key="downline.netgrow_node_id">
																	<v-col cols="12" sm="12" md="4" class="d-flex align-start pb-0">
																		<v-icon color="grey">mdi-account-circle-outline</v-icon>
																		<div class="font-size-9 cl-grey text-capitalize ml-1">
																			<div v-html="$options.filters.longText(downline.member_name, 25)"></div>
																			<div class="d-block font-size-9 cl-primary font-weight-600">{{ downline.network_code }}</div>
																		</div>
																	</v-col>
																	<v-col cols="6" sm="6" md="3" class="px-sm-0 pb-0 text-left text-md-right">
																		<div class="font-size-8 text-uppercase font-weight-600" :style="{color: getNetworkTypeColor(downline.network_rank)}">{{ getNetworkTypeText(downline.network_rank) }}</div>
																	</v-col>
																	<v-col cols="6" sm="6" md="2" class="px-sm-0 pb-0 text-right text-md-center">
																		<div class="font-size-9 cl-grey font-weight-500 text-capitalize">{{ downline.netgrow_node_position }}</div>
																	</v-col>
																	<v-col cols="12" sm="12" md="3" class="pt-0 pb-0 pt-sm-3 text-left text-md-right">
																		<div class="font-size-9 cl-grey">{{ downline.member_join_datetime | formatTgl('DD MMM YYYY') }}</div>
																	</v-col>
																</v-row>
															</template> -->

															<!-- <template v-else> -->
																<div class="d-flex flex-column fill-height align-center justify-center pa-5" style="height: 100%;">
																	<v-icon color="grey" large>mdi-information-outline</v-icon>
																	<div class="font-size-10 mt-4 text-center cl-grey">Belum ada data daftar downline yang ditampilkan.</div>
																</div>
															<!-- </template> -->
														</v-card-text>
													</v-card>
												</v-tab-item>
											</v-tabs-items>
											
											<div class="pb-3"></div>
										</v-card>
									</v-col>
								</v-scroll-x-reverse-transition>
							</v-row>
						</v-col>
					</v-row>
				</div>
			</template>

			<template v-else>
				<loadernetwork :isActiveMember="isActiveMember" :networkType="networkType"></loadernetwork>
			</template>
		</template>
		<!-- growth network summary -->

		<Announcement></Announcement>

	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import loaderDashboard from './components/loaderDashboard'
import loaderNetwork from './components/loaderNetwork'
import upgradeDateAlert from '@/components/upgradeDateAlert'
import Announcement from './components/Announcement'
import Certificate from './components/Certificate'

import moment from 'moment';
moment.locale('id');

export default {
	components: {
		apexchart: VueApexCharts,
		loaderdashboard: loaderDashboard,
		loadernetwork: loaderNetwork,
		'upgradedate-alert': upgradeDateAlert,
		Announcement,
		Certificate
	},
	data() {
		function formatRupiah(bilangan) {
			if (bilangan == 0) {
				return 0
			} else if (bilangan && bilangan >= 1000) {
				var	reverse = bilangan.toString().split('').reverse().join(''),
				ribuan 	= reverse.match(/\d{1,3}/g);
				ribuan	= ribuan.join('.').split('').reverse().join('');
	
				return ribuan;
			} else {
				return Number(bilangan.toFixed(2))
			}
		}

		function formatKomisLabel(label) {
			var	text = label.replace('Komisi', 'K. ').replace('Repeat Order', 'RO')
			return text;
		}

		return {
			tab: null,
			loading: false,
			growthLoading: false,
			fiveDownline: '',
			isActiveMember: false,
			networkType: null,
			isqualifiedCircle: true,
			kemitraan: [
				{
					type: 'pramitra',
					color: '#03bb5a',
					belanja: '0',
					badges: '/assets/icon/pramitra.svg',
					classText: 'mitra-pra'
				},
				{
					type: 'basic',
					color: '#fff',
					belanja: '0',
					badges: '/assets/icon/basic.svg',
					classText: 'mitra-basic'
				},
				{
					type: 'silver',
					color: '#688389',
					belanja: '1.500.000 - 4.499.000',
					badges: '/assets/icon/silver.svg',
					classText: 'mitra-silver'
				},
				{
					type: 'gold',
					color: '#6e490f',
					belanja: '4.500.000 - 14.999.000',
					badges: '/assets/icon/gold.svg',
					classText: 'mitra-gold'
				},
				{
					type: 'diamond',
					color: '#2a4fd6',
					belanja: '15.000.000 - 30.000.000',
					badges: '/assets/icon/diamond.svg',
					classText: 'mitra-diamond'
				},
				{
					type: 'business',
					color: '#bf1404',
					belanja: '15.000.000 - 30.000.000',
					badges: '/assets/icon/business.svg',
					classText: 'mitra-business'
				}
			],

			summaryKomisi: {
				series: [{
					name: 'Komisi',
					data: []
				},{
					name: 'Saldo',
					data: []
				}, {
					name: 'Dibayarkan',
					data: []
				}],
				chartOptions: {
					chart: {
						type: 'bar',
						height: 500
					},
					plotOptions: {
						bar: {
							horizontal: true,
							dataLabels: {
								position: 'top',
							},
						}
					},
					dataLabels: {
						enabled: false,
						offsetX: -6,
						style: {
							fontSize: '9px',
							colors: ['#fff']
						},
						background: {
							padding: 6
						},
						formatter: function(value) {
							if(value != undefined) return 'tes' + formatRupiah(value);
						}
					},
					stroke: {
						show: true,
						colors: ['#fff']
					},
					tooltip: {
						shared: true,
						intersect: false,
						y: {
							formatter: function(value) {
								if(value != undefined) return 'Rp ' + formatRupiah(value);
							}
						},
					},
					xaxis: {
						categories: [],
						labels: {
							formatter: function(value) {
								if(value != undefined) return formatRupiah(value);
							}
						}
					},
				},
			},

			rincianKomisi: {
				series: [],
				chartOptions: {
					chart: {
						size: '120%'
					},
					colors: ['#feb019', '#ff4560', '#775dd0', '#24ae21', '#d2dc46', '#fb5d00'],
					labels: [],
					responsive: [{
						breakpoint: 480,
						options: {
							chart: {
								width: '100%',
								height: 350
							},
							legend: {
								position: 'bottom'
							}
						}
					}],
					legend: {
						position: 'bottom',
						fontSize: 9,
						formatter: function(seriesName, opts) {
							return [ '<span>' + formatKomisLabel(seriesName) + '</span>', '<span class="font-weight-bold">Rp ' + formatRupiah(opts.w.globals.series[opts.seriesIndex]) + '</span>']
						}
					},
					tooltip: {
						y: {
							formatter: function(value) {
								if(value != undefined) return 'Rp ' + formatRupiah(value);
							}
						}
					},
				},
			},

			netGrow: {
				series: [
					{
            name: 'Registrasi',
            data: []
          }, {
            name: 'Aktivasi',
            data: []
          }
				],

				chartOptions: {
					chart: {
						width: '100%',
						height: 350,
						type: 'area'
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						curve: 'smooth'
					},
					xaxis: {
						// type: 'datetime',
						categories: [],
						show: true,
					},
					tooltip: {
						x: {
							show: true,
							format: 'dd MMM yyyy'
						},
					},
				},
			},

			bonusToday: {
				sponsor: [],
				match: [],
				other: [],
			},

			serialCountList: []
		}
	},
	computed: {
		...mapState('profile', ['myProfile']),
		...mapState('bonus', ['listSummaryBonus', 'listBonusToday']),
		...mapState('network', ['listDownline']),
		...mapState('ewallet', ['ewalletSummary']),
		...mapState('dashboard', ['serialCount', 'growthSummary', 'sponsorPromo', 'extraReward', 'certificate']),
	},
	methods: {
		...mapActions('profile', ['getProfile', 'getProfileMitra', 'getProfilePramitra']),
		...mapActions('bonus', ['getSummaryBonus', 'getDetailBonusToday']),
		...mapActions('network', ['getDownline']),
		...mapActions('ewallet', ['getEwalletSummary']),
		...mapActions('dashboard', ['getGrowthSummary', 'getSerialCount', 'getSponsorPromo', 'getExtraRewardStats', 'getCertificate']),

		getNetworkTypeColor(typeArr) {
			// if(type === 'repeat_order') type = 'silver'
			// const netType = this.kemitraan.find(x => x.type === type)
			// if(netType) return netType.color
			let typeConst = ['pramitra', 'basic', 'silver', 'gold', 'diamond', 'business']
			let selectType = ''
			let netType = null
			
			if (!typeConst.includes(typeArr)) {
				let condition = typeArr.filter(p => p.rank_type_plan_activity == "Reguler")
				let condition2 = typeArr.filter(p => p.rank_type_plan_activity == "Business")
				let condition3 = typeArr.filter(p => p.rank_type_plan_activity == "Mikro")

				if (condition2.length > 0) selectType = condition2[0].rank_type_name
				else if (condition.length > 0) selectType = condition[0].rank_type_name
				else if (condition3.length > 0) selectType = condition3[0].rank_type_name
				else selectType = 'pramitra'

				netType = this.kemitraan.find(x => x.type === selectType)
			} else {
				netType = this.kemitraan.find(x => x.type === typeArr)
			}

			return netType.color
		},

		getNetworkTypeText(typeArr) {
			// (downline.network_type === 'diamond') ? 'Platinum' : (downline.network_type === 'repeat_order') ? 'Silver' : (downline.network_type == 'basic') ? 'Mikro' : downline.network_type
			let selectType = ''
			let typeConst = ['pramitra', 'basic', 'silver', 'gold', 'diamond', 'business']
			if (!typeConst.includes(typeArr)) {
				let condition = typeArr.filter(p => p.rank_type_plan_activity == "Reguler")
				let condition2 = typeArr.filter(p => p.rank_type_plan_activity == "Business")
				let condition3 = typeArr.filter(p => p.rank_type_plan_activity == "Mikro")

				if (condition2.length > 0) selectType = condition2[0].rank_type_plan_activity
				else if (condition.length > 0) selectType = condition[0].rank_type_plan_activity
				else if (condition3.length > 0) selectType = condition3[0].rank_type_plan_activity
				else selectType = 'Pramitra'
			} else {
				selectType = typeArr
			}

			return selectType
		},

		setSerialUpgradeText(types) {
			if (types) {
				const texts = types.split('_to_')
				if (texts.length > 1) {
					return ((texts[0] == 'diamond') ? 'Platinum' : texts[0]) + ' Ke ' + ((texts[1] == 'diamond') ? 'Platinum' : texts[1]) 
				} else {
					return ((texts[0] == 'diamond') ? 'Platinum' : texts[0])
				}
			}
		},

		setSerialAktivasiText(types) {
			if (types) {
				if (types == 'gold star') return 'gold'
				else if (types == 'diamond') return 'platinum'
				else if (types == 'basic') return 'mikro'
				else return types
			}
		},

		goActivation() {
			// this.$router.push({name: 'aktivasi'})
			this.$router.push({name: 'aktivasi-mitra', query: { id: this.myProfile.member_id }})
		},

		goProfile() {
			this.$router.push({name: 'profile'})
		},

		sliceDownline() {
			let cloneDownline = [...this.listDownline]
			this.fiveDownline = cloneDownline.slice(0,10)
		},

		getNetworkType(Nettype) {
			let selectType = ''
			if (Nettype) {
				let condition = Nettype.filter(p => p.rank_type_plan_activity == "Reguler")
				let condition2 = Nettype.filter(p => p.rank_type_plan_activity == "Business")
				let condition3 = Nettype.filter(p => p.rank_type_plan_activity == "Mikro")

				if (condition2.length > 0) selectType = condition2[0].rank_type_name
				else if (condition.length > 0) selectType = condition[0].rank_type_name
				else if (condition3.length > 0) selectType = condition3[0].rank_type_name
				else selectType = 'pramitra'

				this.networkType = this.kemitraan.find(x => x.type === selectType)
			}
		},

		gotoUpgrade() {
			this.$router.push({name: 'upgrade-kemitraan'})
		},

		sortSerialList() {
			let data = this.serialCount
			if (data) {
				let arrSort = data.sort((a, b) => {
					return b.serial_type_child_detail.length - a.serial_type_child_detail.length
				});

				this.serialCountList = arrSort
			}
		},

		getTotalBonus(data) {
			let totalKomisi = 0
			if (Object.keys(data).length > 0) {
				let dataChart = data.arrKomisi.filter((el) => el['label'] !== 'Komisi Unilevel')

				dataChart.map((bonus) => {
					totalKomisi += parseFloat(bonus.acc)
				})
			}

			return totalKomisi
		},

		setDataRincianKomisi(data) {
			if (data) {
				let dataChart = data.filter((el) => el['label'] !== 'Komisi Unilevel')
				
				this.rincianKomisi.series = dataChart.map((el) => el['acc'])
				this.rincianKomisi.chartOptions.labels = dataChart.map((el) => el['label'])

				const labels = dataChart.map((el) => el['label'])
				for (let i = 0; i < labels.length; i++) {
					this.summaryKomisi.chartOptions.xaxis.categories.push(labels[i].replace('Komisi', '').replace('Repeat Order', 'RO'))
				}
				this.summaryKomisi.series[0].data = dataChart.map((el) => el['acc'])
				this.summaryKomisi.series[1].data = dataChart.map((el) => el['saldo'])
				this.summaryKomisi.series[2].data = dataChart.map((el) => el['paid'])
			}
		},

		async setNetgrowSummaries(data) {
			// console.log('setNetgrowSummaries', data)
			this.netGrow.series[0].data = await data.map((el) => el.member_registration)
			this.netGrow.series[1].data = await data.map((el) => el.member_activation)
			this.netGrow.chartOptions.xaxis.categories = await data.map((el) => el.member_date)

			// console.log(this.netGrow.chartOptions.xaxis.categories)
		},

		async checkMemberActivation(data) {
			// if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			// console.log('check status == ', (data.bin_network_id === "0" || data.bin_network_id === 0 || !data.member_activation_datetime))
			if (data.bin_network_id === "0" || data.bin_network_id === 0 || data.network_type == 'pramitra') this.isActiveMember = false
			else this.isActiveMember = true
		},

		formatKomisiLabel(text) {
			if (text) {
				if (text === 'Komisi Sponsor Repeat Order') return 'Sponsor RO'
				if (text === 'Komisi Pasangan Basic') return 'Pasangan Mikro'
				else return text.replace('Komisi', '')
			} else {
				return '-'
			}
		}
	},
	async created() {
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)

		await this.$store.dispatch('setPageTitle', `Dashboard`)
		this.loading = await true
		await this.checkMemberActivation(data)

		setTimeout(() => {
			if (this.isActiveMember) {
				this.growthLoading = true
				this.getProfileMitra()
				this.getSponsorPromo()
				this.getCertificate()
				this.getDetailBonusToday().then(() => {
					let bonus_sponsor = []
					let bonus_match = []
					let bonus_other = []
					this.listBonusToday.map((bonus) => {
						if (bonus.label !== 'Komisi Unilevel') {
							if (bonus.name.includes('sponsor') && bonus.name !== 'sponsor_ro') bonus_sponsor.push(bonus)
							else if (bonus.name.includes('match')) bonus_match.push(bonus)
							else bonus_other.push(bonus)
						}
					});

					this.bonusToday.other = bonus_other
					this.bonusToday.match = bonus_match
					this.bonusToday.sponsor = bonus_sponsor
				})
				this.getSummaryBonus().then(() => {
					this.setDataRincianKomisi(this.listSummaryBonus.arrKomisi)
				})
				this.getNetworkType(this.myProfile.network_type)
				this.getSerialCount()
				this.getExtraRewardStats()
				// this.getDownline().then(() => {
					// 	this.sliceDownline()
					// })
					this.getGrowthSummary().then(() => {
						if (this.growthSummary) this.setNetgrowSummaries(this.growthSummary)
					})
				setTimeout(() => {
					this.sortSerialList()
					this.growthLoading = false
				}, 1200);
			} else {
				// this.getProfilePramitra()
				this.getProfileMitra()
				this.getNetworkType('pramitra')
			}
		}, 1000);

		await this.getEwalletSummary()

		this.loading = false

		setTimeout(() => {
			this.growthLoading = false
		}, 600);
	}
};
</script>

<style lang="scss">
	.serial-list {
		margin-top: 7px;
		li {
			line-height: 1.1;
		}
	}

</style>